export default "__VITE_ASSET__CpemlyjH__"